"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectItemInput = exports.StyledSelectListItems = exports.StyledSelectMore = exports.StyledSelectItems = exports.StyledOptionLabel = exports.StyledSelectList = exports.StyledSelectListHeader = exports.StyledSelectListWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const focusHover_1 = require("../../../../../styles/focusHover");
const tokens_1 = require("../../../../../styles/tokens");
const Text_1 = require("../../../../Text/Text");
const { blue } = tokens_1.COLOURS.primary;
const { silver, white, stone, cloud, zinc, night } = tokens_1.COLOURS.greyscale;
exports.StyledSelectListWrapper = styled_components_1.default.div `
    ${tokens_1.TYPOGRAPHY.body.base};
    background-color: ${white};
    border-bottom-right-radius: ${tokens_1.SIZES[0.5]};
    border-bottom-left-radius: ${tokens_1.SIZES[0.5]};
    max-height: ${tokens_1.LISTBOX_DROPDOWN_HEIGHT};
    overflow-y: auto;
`;
exports.StyledSelectListHeader = styled_components_1.default.span `
    background: ${cloud};
    font-size: ${tokens_1.SIZES[1.5]};
    font-weight: 700;
    display: block;
    padding: ${tokens_1.SIZES[0.5]} ${tokens_1.SIZES[1.5]};
    text-transform: uppercase;
    border-top: ${(props) => props.theme === "MULTISELECTALL"
    ? `1px solid ${night}`
    : `1px solid ${silver}`};
    border-bottom: 1px solid ${silver};
`;
exports.StyledSelectList = styled_components_1.default.ul `
    padding: 0;
    margin: 0;
    list-style: none;

    li:first-of-type {
        label {
            border-top: ${(props) => props.theme === "MULTISELECT" ? `1px solid ${night}` : "none"};
        }
    }

    li:last-of-type {
        label {
            border-bottom-left-radius: ${tokens_1.SIZES[0.5]};
            border-bottom-right-radius: ${tokens_1.SIZES[0.5]};
        }
    }
`;
exports.StyledOptionLabel = (0, styled_components_1.default)(Text_1.Text) ``;
exports.StyledSelectItems = styled_components_1.default.div `
    padding: ${tokens_1.SIZES[1]} ${tokens_1.SIZES[1.5]};
    cursor: pointer;
    display: block;
    color: ${(props) => props.color || zinc};
    border-top: 1px solid ${silver};
    margin: 0;
    outline: none;

    &:hover,
    &:active,
    &:focus,
    &:focus-visible {
        background: ${blue[5]};
    }

    &[aria-disabled="true"] {
        ${exports.StyledOptionLabel} {
            color: ${stone};
        }
    }

    &[aria-active="true"] {
        color: ${stone};
    }

    &:focus&:focus,
    &:focus-visible {
        ${focusHover_1.focusOnlyInsetStyles}
    }

    &[aria-selected="true"] {
        background: ${blue[5]};
        border-left: ${`3px solid ${blue[100]}`};
    }
`;
exports.StyledSelectMore = styled_components_1.default.div `
    padding: ${tokens_1.SIZES[1]} ${tokens_1.SIZES[1.5]};
    cursor: pointer;
    color: ${zinc};
    border-top: 1px solid ${silver};
    margin: 0;
    text-align: center;
    background: ${cloud};
    font-size: ${tokens_1.SIZES[1.5]};
    font-weight: 700;
    text-transform: uppercase;

    &:hover {
        background: ${blue[5]};
    }
`;
exports.StyledSelectListItems = styled_components_1.default.label `
    padding: ${tokens_1.SIZES[1]} ${tokens_1.SIZES[1.5]};
    cursor: pointer;
    display: block;
    color: ${(props) => props.color || zinc};
    background: ${white};
    border-top: ${(props) => props.variant === "All" ? "none" : `1px solid ${silver}`};
    margin: 0;

    &:hover {
        background: ${blue[5]};
    }

    &[aria-disabled="true"] {
        color: ${stone};
    }

    &:focus {
        background: ${blue[5]};
        border-left: ${`3px solid ${blue[100]}`};
        box-shadow: none !important;
    }
`;
exports.StyledSelectItemInput = styled_components_1.default.input `
    margin: 0 ${tokens_1.SIZES[1]} 0 0;
    cursor: pointer;
`;
//# sourceMappingURL=SelectList.styles.js.map